<template>

  <t-page>


    <t-page-list :title="t('list-of') + currentPage.pageTitle" :user-auth="userAuth" msg-return-gender-feminine
                 :total-pages="request.totalPages" :total-elements="request.totalElements" :breadcrumb="breadcrumb"
                 @getPage="getPage">


      <template #search>
        <t-button v-if="userAuth.validation.validationCreate" :text="t('insert') + ' ' + currentPage.singularTitle"
                  :to="currentPage.name + '-form-new'"
                  primary/>
        <t-content-header-search-default @searchChange="searchDefault"
                                         @onClearSearch="clearSearch()"
                                         :filtered-default="filteredDefault" :filtered-advanced="filteredAdvanced"
                                         :search-form="form"/>
      </template>

      <b-table hover :items="request.content" v-if="checkViewListTableDefault()" :busy="!pageListIsLoaded"
               :fields="fields">

        <template #cell(first)="{item}">

          <t-list-link-primary :label="item.person.name" :userAuth="userAuth" :id="item.shippingCompanyNumber"
                               :path="currentPage.path"/>
        </template>

        <template #cell(status)="{item}">
          {{ item.status | statusLabel }}
        </template>

        <template #cell(actions)="{item}">
          <t-list-actions-default :form-path="currentPage.path" :id="item.shippingCompanyNumber" :userAuth="userAuth"/>
        </template>

      </b-table>

      <t-msg v-else warning>{{ t('no-record-found') }}</t-msg>

    </t-page-list>

  </t-page>

</template>
<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageListMixin from "@/mixins/page/pageListMixin"

export default {
  mixins: [pageDefaultMixin, pageListMixin],
  name: 'Department',
  data() {
    return {
      path: "", //Utilizar somente quando fora do padrão
      fields: [
        {key: "first", label: "Transportadora"},
        {key: "person.federalTaxpayer", label: "CNPJ/CPF"},
        {key: "note", label: "Obs."},
        {key: "status", label: "Status"},
        {key: "actions", label: ""},
      ],
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela


      //--------------------------------------------------------------------------------------
    }
  },
  methods: {

    mountedPrepare() {

      this.breadcrumb = [
        {text: 'Configurações', to: {name: 'business-setting'}},
      ]

    },
    async mountedContinued() {


    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela


    //--------------------------------------------------------------------------------------

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedList()

    await this.mountedContinued()

  },
}
</script>
